import update from 'immutability-helper';

update.extend('$addToSet', (values, array) =>
  update(array, { $push: values.filter((value) => !array.includes(value)) }),
);
update.extend('$auto', (value, object) => (object ? update(object, value) : update({}, value)));
update.extend('$sum', (value, object) => object + value);

export const updateState = (currentState, commands) =>
  commands && Object.keys(commands).length ? update(currentState, commands) : currentState;
